export default __webpack_public_path__ + "static/Cheese-rolling-Gloucester-6833df001254a54f82881716c60039f5.jpg";